import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { API_BASE_URL } from '@app/shared/constants/api';
import { RootState } from '@app/store/store';

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  credentials: 'include', // send cookies
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});
